
import router from './router'
router.beforeEach((to, from, next) => {
    // document.title = `物流源-${to.meta.title}`
    next()
})

router.afterEach((to, from) => {

})


// WEBPACK FOOTER //
// ./src/permission.js